import { forwardRef, HTMLAttributes } from 'react';
import { cn } from './cn';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  width?: string | number;
  height?: string | number;
  shape?: 'rect' | 'line' | 'circle';
}

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(function Skeleton(
  { width, height, shape = 'rect', className, style, ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      data-tss-ui=""
      data-shape={shape}
      className={cn('tss-skeleton', className)}
      style={{ width, height, ...style }}
      aria-hidden="true"
      {...rest}
    />
  );
});
